<template>
    <div class="home-view">
        <Topbar />
        <div class="container-fluid text-left pl-2 pr-2 d-flex justify-content-center mt-4 pt-4">
            <div class="card shadow mb-4 col-md-6 m-0 p-0 text-secondary" v-if="this.pedido">
                <div class="card small">
                    <div class="card-header text-white text-center p-1" :style="{ backgroundColor: moduloAtual().color }">
                        DOCUMENTO Nº {{ this.numeroPedido }}
                    </div>
                    <div class="card-body p-2">
                        <ul class="nav nav-tabs small" id="myTab">
                            <li class="nav-item">
                                <a class="nav-link active" id="tab1-tab" data-toggle="tab" href="#tab1" role="tab">DETALHES</a>
                            </li>
                            <li class="nav-item">
                                <a class="nav-link" id="tab2-tab" data-toggle="tab" href="#tab2" role="tab">ITENS</a>
                            </li>
                            <li class="nav-item">
                                <a class="nav-link" id="tab3-tab" data-toggle="tab" href="#tab3" role="tab">HISTÓRICO</a>
                            </li>
                        </ul>
                        <div class="tab-content mt-3" id="myTabContent">
                            <div class="tab-pane fade show active" id="tab1" role="tabpanel">
                                <div class="card small">
                                    <div class="card-header small p-1">
                                        <h6 class="m-0">
                                            <em class="fa fa-database mr-2"></em>
                                            {{ pedido.nomecliente }}
                                        </h6>
                                    </div>
                                    <div class="card-body p-2">
                                        <div class="row">
                                            <div class="col-12">
                                                <label for="numeroPeidido">Nº PEDIDO</label>
                                                <input type="text" readonly id="numeroPeidido" :value="pedido.pedido" class="form-control form-control-sm mb-1 text-danger">
                                            </div>
                                        </div>

                                        <div class="row">
                                            <div class="col-12">
                                                <label for="codigopedido">CÓDIGO PEDIDO</label>
                                                <input type="text" readonly id="codigopedido" :value="pedido.codigopedido" class="form-control form-control-sm mb-1 text-danger">
                                            </div>
                                        </div>

                                        <div class="row">
                                            <div class="col-12">
                                                <label for="statuslib">STATUS</label>
                                                <input type="text" readonly id="statuslib" :value="pedido.statuslib" class="form-control form-control-sm mb-1 text-danger">
                                            </div>
                                        </div>
                                        
                                        <div class="row">
                                            <div class="col-6 pr-1">
                                                <label for="datastatus">DATA STATUS</label>
                                                <input type="text" readonly id="datastatus" :value="dateFormat(pedido.datastatus)" class="form-control form-control-sm mb-1">
                                            </div>
                                            <div class="col-6 pl-1">
                                                <label for="dtentrega">DATA LIMITE</label>
                                                <input type="text" readonly id="dtentrega" :value="dateFormat(pedido.dtentrega)" class="form-control form-control-sm mb-1">
                                            </div>
                                        </div>

                                        <div class="row">
                                            <div class="col-12">
                                                <label for="transportadora">TRANSPORTADORA</label>
                                                <input type="text" readonly id="transportadora" :value="pedido.transportadora" class="form-control form-control-sm mb-1 text-danger">
                                            </div>
                                        </div>

                                        <div class="row">
                                            <div class="col-12">
                                                <label for="servicoentrega">SERVIÇO ENTREGA</label>
                                                <input type="text" readonly id="servicoentrega" :value="pedido.servicoentrega" class="form-control form-control-sm mb-1 text-danger">
                                            </div>
                                        </div>

                                        <div class="row">
                                            <div class="col-6 pr-1">
                                                <label for="numeronf">N° NOTA</label>
                                                <input type="text" readonly id="numeronf" :value="pedido.numeronf" class="form-control form-control-sm mb-1 text-danger">
                                            </div>
                                            <div class="col-6 pl-1">
                                                <label for="emissaonf">DATA EMISSÃO NF</label>
                                                <input type="text" readonly id="idlistaseparacao" :value="dateFormat(pedido.emissaonf)" class="form-control form-control-sm mb-1">
                                            </div>
                                        </div>

                                        <div class="row">
                                            <div class="col-12">
                                                <label for="chavenfe">CHAVE NF-e</label>
                                                <input type="text" readonly id="chavenfe" :value="pedido.chavenfe" class="form-control form-control-sm mb-1 text-danger">
                                            </div>
                                        </div>

                                        <div class="row">
                                            <div class="col-6 pr-1">
                                                <label for="idlistaseparacao">TOTAL NOTA</label>
                                                <input type="text" readonly id="totalnota" :value="pedido.totalnota" class="form-control form-control-sm mb-1">
                                            </div>
                                            <div class="col-6 pl-1">
                                                <label for="idlistaseparacao">LISTA DE SEPARAÇÃO</label>
                                                <input type="text" readonly id="idlistaseparacao" :value="pedido.idlistaseparacao" class="form-control form-control-sm mb-1 text-danger">
                                            </div>
                                        </div>

                                        <div class="row">
                                            <div class="col-6 pr-1">
                                                <label for="totalvolume">VOLUMES</label>
                                                <input type="text" readonly id="totalvolume" :value="parseInt(pedido.totalvolume)" class="form-control form-control-sm mb-1">
                                            </div>
                                            <div class="col-6 pl-1">
                                                <label for="totalpeso">PESO</label>
                                                <input type="text" readonly id="totalpeso" :value="pedido.totalpeso" class="form-control form-control-sm mb-1">
                                            </div>
                                        </div>

                                        <div class="row">
                                            <div class="col-6 pr-1">
                                                <label for="idlistaseparacao">PRÉ-ROMANEIO</label>
                                                <input type="text" readonly id="idlistaseparacao" :value="pedido.idpreromaneiossaida" class="form-control form-control-sm mb-1 text-danger">
                                            </div>
                                            <div class="col-6 pl-1">
                                                <label for="idlistaseparacao">ROMANEIO</label>
                                                <input type="text" readonly id="idlistaseparacao" :value="pedido.idromaneiossaida" class="form-control form-control-sm mb-1 text-danger">
                                            </div>
                                        </div>

                                        <div class="row">
                                            <div class="col-6 pr-1">
                                                <label for="lote_expedicao">LOTE EXPEDIÇÃO</label>
                                                <input type="text" readonly id="lote_expedicao" :value="pedido.lote_expedicao" class="form-control form-control-sm mb-1 text-danger">
                                            </div>
                                            <div class="col-6 pl-1">
                                                <label for="dataexpedicao">DATA EXPEDIÇÃO</label>
                                                <input type="text" readonly id="dataexpedicao" :value="dateFormat(pedido.dataexpedicao)" class="form-control form-control-sm mb-1">
                                            </div>
                                        </div>

                                        <table class="table table-bordered table-striped small">
                                            <caption class="d-none"></caption>
                                            <thead>
                                                <th class="p-1">RASTREIO</th>
                                                <th class="p-1">CON.</th>
                                                <th class="p-1">BIP. PRÉ</th>
                                                <th class="p-1">BIP. EXP.</th>
                                                <th class="p-1">EXP.</th>
                                            </thead>
                                            <tbody>
                                                <tr v-for="(item) in pedido.barrasMercadoEnvios" :key="item.registro">
                                                    <td>{{ item.registro }}</td>
                                                    <td class="text-center p-1">
                                                        <span v-if="item.concluidos === parseInt(pedido.totalvolume)">
                                                            <em class="fa fa-check-circle text-success"></em>
                                                        </span>
                                                        <span v-if="item.concluidos < parseInt(pedido.totalvolume)">
                                                            <em class="fa fa-times-circle text-danger"></em>
                                                        </span>
                                                    </td>
                                                    <td class="text-center p-1">
                                                        <span v-if="item.bipados_pre === parseInt(pedido.totalvolume)">
                                                            <em class="fa fa-check-circle text-success"></em>
                                                        </span>
                                                        <span v-if="item.bipados_pre < parseInt(pedido.totalvolume)">
                                                            <em class="fa fa-times-circle text-danger"></em>
                                                        </span>
                                                    </td>
                                                    <td class="text-center p-1">
                                                        <span v-if="item.bipados_expedicao === parseInt(pedido.totalvolume)">
                                                            <em class="fa fa-check-circle text-success"></em>
                                                        </span>
                                                        <span v-if="item.bipados_expedicao < parseInt(pedido.totalvolume)">
                                                            <em class="fa fa-times-circle text-danger"></em>
                                                        </span>
                                                    </td>
                                                    <td class="text-center p-1">
                                                        <span v-if="pedido.idromaneiossaida !== null && pedido.idromaneiossaida > 0">
                                                            <em class="fa fa-check-circle text-success"></em>
                                                        </span>
                                                        <span v-if="pedido.idromaneiossaida === null || pedido.idromaneiossaida === 0">
                                                            <em class="fa fa-times-circle text-danger"></em>
                                                        </span>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>

                                <div class="card small mt-2">
                                    <div class="card-header small p-1">
                                        <h6 class="m-0">
                                            <em class="fa fa-user mr-2"></em>
                                            Destinatário
                                        </h6>
                                    </div>
                                    <div class="card-body p-2">

                                        <div class="row">
                                            <div class="col-12">
                                                <label for="nomedest">NOME</label>
                                                <input type="text" readonly id="nomedest" :value="pedido.nomedest" class="form-control form-control-sm mb-1 text-danger">
                                            </div>
                                        </div>
                                        
                                        <div class="row">
                                            <div class="col-12">
                                                <label for="endereco">ENDERECO</label>
                                                <input type="text" readonly id="endereco" :value="pedido.endereco" class="form-control form-control-sm mb-1">
                                            </div>
                                        </div>

                                        <div class="row">
                                            <div class="col-12">
                                                <label for="cidade">CIDADE</label>
                                                <input type="text" readonly id="cidade" :value="pedido.cidade" class="form-control form-control-sm mb-1">
                                            </div>
                                        </div>

                                        <div class="row">
                                            <div class="col-12">
                                                <label for="bairro">BAIRRO</label>
                                                <input type="text" readonly id="bairro" :value="pedido.bairro" class="form-control form-control-sm mb-1">
                                            </div>
                                        </div>

                                        <div class="row">
                                            <div class="col-6 pr-1">
                                                <label for="lote_expedicao">INSCRIÇÃO ESTATUAL</label>
                                                <input type="text" readonly id="inscricaoest" :value="pedido.inscricaoest" class="form-control form-control-sm mb-1">
                                            </div>
                                            <div class="col-6 pl-1">
                                                <label for="numero">NÚMERO</label>
                                                <input type="text" readonly id="numero" :value="pedido.numero" class="form-control form-control-sm mb-1 ">
                                            </div>
                                        </div>

                                        <div class="row">
                                            <div class="col-12">
                                                <label for="complemento">COMPLEMENTO</label>
                                                <input type="text" readonly id="complemento" :value="pedido.complemento" class="form-control form-control-sm mb-1">
                                            </div>
                                        </div>

                                        <div class="row">
                                            <div class="col-6 pr-1">
                                                <label for="cnpjdest">CEP</label>
                                                <input type="cep" readonly id="cnpjdest" :value="pedido.cep" class="form-control form-control-sm mb-1">
                                            </div>
                                            <div class="col-6 pl-1">
                                                <label for="cnpjdest">CNPJ DESTINATÁRIO</label>
                                                <input type="text" readonly id="cnpjdest" :value="pedido.cnpjdest" class="form-control form-control-sm mb-1r">
                                            </div>
                                        </div>
                                        <hr>

                                        <div class="row">
                                            <div class="col-12">
                                                <label for="nomeembarcador">EMBARCADOR</label>
                                                <input type="text" readonly id="nomeembarcador" :value="pedido.nomeembarcador" class="form-control form-control-sm mb-1">
                                            </div>
                                        </div>

                                        <div class="row">
                                            <div class="col-12">
                                                <label for="cnpjembarcador">CNPJ EMBARCADOR</label>
                                                <input type="text" readonly id="cnpjembarcador" :value="pedido.cnpjembarcador" class="form-control form-control-sm mb-1">
                                            </div>
                                        </div>

                                    </div>
                                    
                                </div>
                                <br>
                                <br>
                            </div>
                            <div class="tab-pane fade small" id="tab2" role="tabpanel">
                                <table class="table table-bordered table-striped small">
                                    <caption class="d-none"></caption>
                                    <thead>
                                        <th class="p-1">PRODUTO</th>
                                        <th class="p-1">SKU</th>
                                        <th class="p-1">COD.BARRAS</th>
                                        <th class="p-1">QTDE</th>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(item) in pedido.itensPedido" :key="item.idprodutos">
                                            <td class="small p-1">{{ item.descricao }}</td>
                                            <td class="p-1">{{ item.sku }}</td>
                                            <td class="p-1">{{ item.codbarras }}</td>
                                            <td class="p-1">{{ item.qtde }}</td>
                                        </tr>
                                    </tbody>
                                </table>
                                <br>
                                <br>
                            </div>
                            <div class="tab-pane fade small" id="tab3" role="tabpanel">
                                <table class="table table-bordered table-striped small">
                                    <caption class="d-none"></caption>
                                    <thead>
                                        <th class="p-1">STATUS</th>
                                        <th class="p-1">DATA</th>
                                        <th class="p-1">USUÁRIO</th>
                                        <th class="p-1">OBS</th>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(item) in pedido.historico" :key="item.iddocumentos_has_status">
                                            <td class="small p-1">{{ item.descricao }}</td>
                                            <td class="p-1">{{ dateFormat(item.data) }}</td>
                                            <td class="p-1">{{ item.usuario }}</td>
                                            <td class="small p-1">{{ item.obs }}</td>
                                        </tr>
                                    </tbody>
                                </table>
                                <br>
                                <br>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <LogoutModal />
        <FooterBar />
    </div>
</template>
  
  
  <script>
  // @ is an alias to /src
  import Topbar from '@/components/Topbar.vue'
  import FooterBar from '@/components/FooterBar.vue'
  import LogoutModal from '@/components/LogoutModal.vue'
  import ViewMixin from './ViewMixin'
  import { DEFAULT_ERROR_MESSAGE, ServerErrorException, TokenInvalidoException } from '../services/exceptions'
  import api, { getUsername, getPerfil } from '../services/api'
  import { dateFormat } from '../utils';
  
  export default {
    name: 'ConsultaPedidoResultado',
    mixins: [
      ViewMixin
    ],
    components: {
      Topbar,
      LogoutModal,
      FooterBar
    },
  
    data: () => {
      return {
        numeroPedido: null,
        pedido: null
      };
    },
  
    async mounted() {
      try {
        await this.validarToken();
        this. setNumeroPedido();
        await this.getDetalhesPedido();
      } catch (e) {
        if (e instanceof TokenInvalidoException) {
          this.handleTokenInvalidoException();
        } else if (e instanceof ServerErrorException) {
          alert(e.message);
        } else {
          alert(DEFAULT_ERROR_MESSAGE);
        }      
      }
    },
  
    methods: {
      getUsername,
      getPerfil,
      dateFormat,

      async validarToken() {
        this.carregando = true;
  
        await api.get("/validar-token");
  
        this.carregando = false;
      },

      setNumeroPedido() {
        this.numeroPedido = this.$route.params.pedido
      },

      async getDetalhesPedido() {
        this.carregando = true;
        try {
            let result  = await api.post("/pesquisa/pedido/detalhes", {idDocumento: this.$route.params.pedido});
            this.pedido = result.data.pedido;
        } catch (error) {
            console.log(error);
        }
        this.carregando = false;
      }
    }
  }
  </script>
  
  <style scoped lang="scss">    
  
    .home-view {
      height: 100%;
    }
  
    .container-img {
      height: auto;
      display: flex;
      justify-content: center;
      align-self: center;
    }

    .form-control-sm {
        font-size: 9px;
        height: 16px;
    }

    label {
        margin: 0px;
    }

  </style>
  